"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionWrapper = void 0;
const web3_js_1 = require("@solana/web3.js");
const Logger_1 = require("./Logger");
class TransactionWrapper {
    constructor(connection, signer, transaction, feePayer) {
        this._logger = new Logger_1.Logger('@soltoolkit/TransactionWrapper');
        this._transaction = transaction ? transaction : new web3_js_1.Transaction();
        this._connection = connection;
        this._signer = signer;
        this._feePayer = feePayer;
    }
    static create({ transaction, rpcEndpoint, connection, connectionManager, signer, config, changeConn = false }) {
        var conn;
        if (connection) {
            conn = connection;
        }
        else if (rpcEndpoint) {
            conn = new web3_js_1.Connection(rpcEndpoint, config);
        }
        else if (connectionManager) {
            conn = connectionManager.connSync({ changeConn });
        }
        else {
            throw new Error('No connection or rpc endpoint provided');
        }
        return new TransactionWrapper(conn, signer, transaction);
    }
    sendAndConfirm({ serialisedTx, maximumRetries = 5, commitment = 'max' }) {
        return __awaiter(this, void 0, void 0, function* () {
            var signature;
            var tries = 0;
            var isTransactionConfirmed = false;
            while (tries < maximumRetries && // not exceeded max retries
                !isTransactionConfirmed // no confirmation of any signature
            ) {
                try {
                    signature = yield this.sendTx({ serialisedTx });
                    const result = yield this.confirmTx({ signature, commitment });
                    if (result.value.err !== null) {
                        throw new Error(`RPC failure: ${JSON.stringify(result.value.err)}`);
                    }
                    this._logger.debug(result);
                    isTransactionConfirmed = true;
                }
                catch (e) {
                    if (e.message.includes('RPC failure')) {
                        throw e;
                    }
                    else {
                        this._logger.warn('Transaction failed, retrying...', e);
                        tries++;
                    }
                }
            }
            if (signature === undefined || !isTransactionConfirmed) {
                throw this._logger.makeError(`Transaction failed after ${tries} tries`);
            }
            return signature;
        });
    }
    addBlockhashAndFeePayer(feePayer) {
        return __awaiter(this, void 0, void 0, function* () {
            const latestBlockhash = yield this._connection.getLatestBlockhash();
            this._transaction.recentBlockhash = latestBlockhash.blockhash;
            this._transaction.feePayer = feePayer || this._feePayer || this._signer;
            if (this._transaction.feePayer === undefined) {
                throw new Error('Fee payer must be defined');
            }
            // this._logger.debug('blockhash:', this._transaction.recentBlockhash);
            // this._logger.debug('fee payer:', this._transaction.feePayer.toBase58());
            return this;
        });
    }
    sign({ wallet, signer, tx }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wallet && !signer) {
                throw new Error('No wallet or signer provided');
            }
            if (tx === undefined) {
                tx = this._transaction;
            }
            if (wallet) {
                var signedTx = yield wallet.signTransaction(tx);
                return signedTx;
            }
            else if (signer) {
                tx.sign(signer);
                return tx;
            }
            else {
                throw new Error('Wallet or Signer must be provided');
            }
        });
    }
    sendTx({ serialisedTx }) {
        return __awaiter(this, void 0, void 0, function* () {
            var sig = yield this._connection.sendRawTransaction(serialisedTx);
            return sig;
        });
    }
    confirmTx({ signature, commitment = 'max' }) {
        return __awaiter(this, void 0, void 0, function* () {
            const latestBlockHash = yield this._connection.getLatestBlockhash(commitment);
            return yield this._connection.confirmTransaction({
                signature: signature,
                blockhash: latestBlockHash.blockhash,
                lastValidBlockHeight: latestBlockHash.lastValidBlockHeight
            }, commitment);
        });
    }
    static confirmTx({ connection, connectionManager, signature, commitment = 'max', changeConn = false, airdrop }) {
        return __awaiter(this, void 0, void 0, function* () {
            // if connection is not provided, use connection manager
            if (connection === undefined && connectionManager !== undefined) {
                connection = connectionManager.connSync({ changeConn, airdrop });
            }
            else if (connection === undefined && connectionManager === undefined) {
                throw new Error('No connection or connection manager provided');
            }
            if (connection === undefined) {
                throw new Error('Connection is undefined');
            }
            const latestBlockHash = yield connection.getLatestBlockhash(commitment);
            return yield connection.confirmTransaction({
                signature: signature,
                blockhash: latestBlockHash.blockhash,
                lastValidBlockHeight: latestBlockHash.lastValidBlockHeight
            }, commitment);
        });
    }
}
exports.TransactionWrapper = TransactionWrapper;
